import { ReactElement } from 'react';

const FVSStep19AlertContent2 = (): ReactElement => (
  <>
    <div>
      If the person you are applying for has incurred traffic fines in their name but someone else was driving and they are found to be eligible, they are able to nominate a driver within six months of receiving the outcome of the application – if they feel safe to do so.
    </div>
    <br />
    <div>
      You can provide the driver’s details below now if you wish but we will always contact you before processing a nomination as we understand the person’s situation may change. Their decision to nominate them or not will not affect the outcome of the application.
    </div>
  </>
);

export default FVSStep19AlertContent2;
